<script setup>
    import { useI18n } from 'vue-i18n';
    import OrderingCodesTableRow from "./components/OrderingCodesTableRow.vue";
    import { onMounted, onUnmounted } from 'vue';

    const { t } = useI18n();

    const props = defineProps({
        orderingCodes: {
            type: Object,
            default: null,
        },

        shops: {
            type: Object,
            default: null,
        },

        productHeadline: {
            type: String,
            default: null,
        },

        shopTitleLevelClass: {
            type: String,
            default: null,
        },

        productBrand: {
            type: String,
            default: null,
        },

    });

    function hidePopups() {
        document.querySelectorAll(".product-ordering-container .popup-container").forEach(popup => {
            popup.classList.remove("is-active");
        });
    }

    onMounted(() => {
        document.addEventListener('keydown', function (e) {
            if (e.code === 'Escape') {
                hidePopups();
            }
        });
        document.addEventListener('click', function (e) {
            if (e.target.nodeName !== 'A' && e.target.nodeName !== 'BUTTON') {
                hidePopups();
            }
        });
    });

    onUnmounted(() => {
        document.removeEventListener('keydown', function (e) {
            if (e.code === 'Escape') {
                hidePopups();
            }
        });
        document.addEventListener('click', function (e) {
            if (e.target.nodeName !== 'A' && e.target.nodeName !== 'BUTTON') {
                hidePopups();
            }
        });
    });

</script>

<template>
    <div class="product-ordering-container ">
        <table>
            <thead>
                <tr>
                    <th class="title is-6">{{ t('productDetails.Ordering.Codes.TableTitle.Type') }}</th>
                    <th class="title is-6">{{ t('productDetails.Ordering.Codes.TableTitle.Description') }}</th>
                    <th class="title is-6">{{ t('productDetails.Ordering.Codes.TableTitle.Order') }}</th>
                    <th class="hidden-title">{{ t('productDetails.Ordering.Codes.TableTitle.Availability') }}</th>
                </tr>
            </thead>
            <tbody>
                <OrderingCodesTableRow
                    v-for="(orderingCodesGroup, index) in orderingCodes"
                    :key="`product-${index}`"
                    :data="orderingCodesGroup"
                    :index="index"
                    :shops ="shops"
                    :shop-title-level-class="shopTitleLevelClass"
                    :product-brand="productBrand"
                    :product-headline="productHeadline"
                />
            </tbody>
        </table>
    </div>
</template>

<style lang="scss">
    @import '../../../scss/variables';
    @import '../../../scss/utilities/all';
    @import '../../../scss/forms/_all.scss';

</style>
